import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
// @ts-expect-error: Font package has no TypeScript types
import '@fontsource/maven-pro';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';

import App from './app/App';
import './index.css';
import { theme } from './theme';


const container = document.getElementById('root');

if (!container) {
  throw new Error('Root container not found');
}

const root = createRoot(container);

root.render(
  <StrictMode>
    <MuiThemeProvider theme={theme}>
      <StyledThemeProvider theme={theme}>
        <App />
      </StyledThemeProvider>
    </MuiThemeProvider>
  </StrictMode>,
);
